/* eslint-disable @typescript-eslint/no-var-requires, global-require, import/no-import-module-exports */
import { combineReducers, createStore } from '@reduxjs/toolkit';

import { bindMiddleware } from '@redux/appStore';
import loginRootReducer from '@redux/reducers/LoginRootReducer';

const initializeLoginStore = () => {
    const store = createStore(combineReducers(loginRootReducer), bindMiddleware());

    /**
     * HMR setup has to be in the same file that imports the modules, and yes,
     * it has to be literal strings so we can't really make it DRY.
     */
    if (process.env.NODE_ENV !== 'production' && module?.hot) {
        // Login page reducer + saga
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('@redux/reducers/LoginRootReducer', () => {
            const nextRootReducer = require('@redux/reducers/LoginRootReducer').default;
            store.replaceReducer(combineReducers(nextRootReducer) as any);
        });
    }

    return store;
};

export default initializeLoginStore;
